/*
 * jQuery Mobile Slide Menu plugin
 */
; (function ($) {
	function MobileSlideNav(options) {
		this.options = $.extend({
			slider: '> ul',
			listItems: 'li',
			opener: '> a',
			dropdown: '.drop',
			btnBackClass: 'btn-back',
			btnBackText: 'Back', // null - parent link text
			activeClass: 'active-item',
			hasDropClass: 'has-drop',
			animSpeed: 500
		}, options);

		this.init();
	}

	MobileSlideNav.prototype = {
		init: function () {
			if (this.options.holder) {
				this.findElements();
				this.attachEvents();
				this.makeCallback('onInit', this);
			}
		},
		findElements: function () {
			this.win = $(window);
			this.holder = $(this.options.holder);
			this.slider = this.holder.find(this.options.slider);
			this.listItems = this.slider.find(this.options.listItems).has(this.options.dropdown).addClass(this.options.hasDropClass);
			this.itemLinks = $();
			this.allButtons = $();
			this.levelCounter = 0;
			this.isAnimate = false;
		},
		attachEvents: function () {
			var self = this;

			this.listItems.each(function () {
				var item = $(this);
				var opener = item.find(self.options.opener);
				var drop = item.find('>' + self.options.dropdown);
				var btnBack = $('<a href="#" class="' + self.options.btnBackClass + '"></a>');

				if (self.options.btnBackText) {
					btnBack.text(self.options.btnBackText);
				} else {
					btnBack.text(opener.text());
				}

				btnBack.prependTo(drop);
				self.itemLinks = self.itemLinks.add(opener);
				self.allButtons = self.allButtons.add(btnBack);

				opener.data({
					item: item,
					btnBack: btnBack
				});
			});

			this.itemLinks.each(function () {
				var currOpener = $(this);
				var btnBack = currOpener.data('btnBack');

				if (btnBack.length) {
					btnBack.on('click', function (e) {
						e.preventDefault();
						self.hideDrop(currOpener.data('item'));
					});
				}
			});

			this.clickHandler = function (e) {
				e.preventDefault();
				self.showDrop($(e.currentTarget).data('item'));
			};

			this.itemLinks.on('click', this.clickHandler);

			this.onPageResize = function () {
				self.resizeHandler();
			};

			this.resizeHandler();
			this.win.on('resize orientationchange load', this.onPageResize);
		},
		showDrop: function (item) {
			var self = this;

			if (this.isAnimate) return;

			this.levelCounter++;

			this.slideNav({
				drop: item.find(self.options.dropdown)
			});

			item.siblings().removeClass(this.options.activeClass);
			item.addClass(this.options.activeClass);
		},
		hideDrop: function (item) {
			var self = this;

			if (this.isAnimate) return;

			this.levelCounter--;

			this.slideNav({
				drop: this.levelCounter === 0 ? this.slider : item.closest(self.options.dropdown),
				complete: function () {
					item.removeClass(self.options.activeClass);
				}
			});
		},
		hideAllDropdowns: function () {
			var self = this;

			this.levelCounter = 0;

			this.slideNav({
				noAnim: true,
				complete: function () {
					self.listItems.removeClass(self.options.activeClass);
				}
			});
		},
		slideNav: function (options) {
			var self = this;

			this.isAnimate = true;

			this.slider.stop().animate({
				marginLeft: -this.levelCounter * this.navWidth
			}, (options && options.noAnim) ? 0 : this.options.animSpeed, function () {
				if (options && options.complete) {
					options.complete();
				}

				self.isAnimate = false;
			});

			if (options && options.drop) {
				setTimeout(function () {
					self.holder.animate({
						height: options.drop.outerHeight()
					}, self.options.animSpeed);
				}, 10);
			}
		},
		resizeHandler: function () {
			this.navWidth = this.holder.outerWidth(true);

			this.slideNav({
				noAnim: true
			});
		},
		destroy: function () {
			var self = this;

			this.win.off('resize orientationchange load', this.onPageResize);
			this.itemLinks.off('click', this.clickHandler);

			setTimeout(function () {
				self.slider.stop().removeAttr('style');
			}, 10);

			this.listItems.removeClass(this.options.activeClass);
			this.allButtons.remove();
			this.holder.removeAttr('style').removeData('MobileSlideNav');
		},
		makeCallback: function (name) {
			if (typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);

				args.shift();
				this.options[name].apply(this, args);
			}
		}
	};

	// jQuery plugin interface
	$.fn.mobileSlideNav = function (opt) {
		return this.each(function () {
			jQuery(this).data('MobileSlideNav', new MobileSlideNav($.extend(opt, {
				holder: this
			})));
		});
	};
}(jQuery));



